// extracted by mini-css-extract-plugin
module.exports = {"reference":"Reference_reference__M19Ld"};